module.exports = __webpack_public_path__ + "resources/sass/fn/fonts/OpenSans-Bold-webfont.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/sass/fn/fonts/OpenSans-Bold-webfont.svg
// module id = 372
// module chunks = 0